import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from '@/i18n/LanguageContext';
import AppShell from '@/components/AppShell';
import Accueil from '@/pages/Accueil';
import Cabinet from '@/pages/Cabinet';
import Competences from '@/pages/Competences';
import Formations from '@/pages/Formations';
import Equipe from '@/pages/Equipe';
import Valeurs from '@/pages/Valeurs';
import Honoraires from '@/pages/Honoraires';
import Contact from '@/pages/Contact';

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<AppShell />}>
              <Route path="/" element={<Accueil />} />
              <Route path="/cabinet" element={<Cabinet />} />
              <Route path="/competences" element={<Competences />} />
              <Route path="/formations" element={<Formations />} />
              <Route path="/equipe" element={<Equipe />} />
              <Route path="/valeurs" element={<Valeurs />} />
              <Route path="/honoraires" element={<Honoraires />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Accueil />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
